export const IMG = {
  hero: "/img/hero.jpg",
  welcome: "/img/welcome.jpg",
  pr: "/img/pr.jpg",
  human: "/img/human.jpg",
  riri: "/img/riri.jpg",
  jack: "/img/jack.jpg",
  hilltop: "/img/hilltop.jpg",
};

export const TRAILER_URL = "";

export const SHOW = {
  title: "Then Came Sam",
  format: "Live-Action Sitcom · Half-Hour",
  logline:
    "An ultra-intelligent, solid all-black cat named Samantha rules her Malibu hilltop estate like an A-list celebrity, turning every room into a high-stakes stage where she is the supreme star, while her calm, cool, and collected siblings watch her chaotic coastal genius unfold.",
  openingVisual:
    "A sweeping cinematic drone shot over a gorgeous, sun-drenched modern estate perched high on the Malibu hills, overlooking the sparkling Pacific Ocean, the undisputed domain of our star.",
};

export const QUOTES = {
  featured: {
    text: "Let the record show: I bought this house. I pay for this house. I am the name on the mailbox. ... She's in the mailbox, isn't she.",
    by: "The Human, Pilot — Beat 4, \"The Call Sheet\"",
  },
  mid: {
    text: "Every room is a stage. Every doorway is a red carpet. And every guest who crosses that threshold pays the toll: one kiss, no exceptions.",
    by: "Pilot — Beat 6, \"The Welcome Committee\"",
  },
  closing: {
    text: "He thinks he found this house. He thinks he found us. Darling, nobody finds anything in Malibu. Then came Sam.",
    by: "Samantha's final look to camera, Pilot Tag",
  },
};

export const CHARACTERS = [
  {
    id: "samantha",
    name: "Samantha",
    alias: "\"Sam\"",
    role: "The Malibu Star & Mastermind",
    img: IMG.hilltop,
    gallery: [
      { src: IMG.welcome, label: "Samantha / Welcome Committee" },
      { src: IMG.pr, label: "Samantha / Public Relations" },
    ],
    look: "A sleek, solid all-black cat with glowing gold eyes and, on official business, a thin gold chain.",
    summary:
      "The absolute focal point of the series. Samantha acts like a pampered mega-celebrity. She's a hilarious paradox: equal parts absolute dictator (\"a pistol\" with an intense agenda) and a loving sweetheart who runs the welcome committee.",
    traits: [
      "Ultra-intelligent strategist who's always three rooms ahead of everyone",
      "Runs the Welcome Committee: mandatory door-security kisses for every arrival",
      "Keeps a soft spot for her men: the Human and brother Jack",
      "Always patrolling, and keeps inventing impossible new hiding spots",
      "Holds court from her custom command chair when a moment calls for gravitas",
    ],
    comedic:
      "She's never still. Sam is the engine of every episode: she zips through frame, takes over rooms, and turns ordinary errands into premieres. The joke is that she's always right.",
    heart:
      "Under the diva act is fierce loyalty. When things truly fall apart, Sam is the first one at the door, and the kisses are real.",
    catchphrase: "Every entrance is an event.",
  },
  {
    id: "riri",
    name: "RiRi",
    alias: "The Collected Sister",
    role: "The Unbothered Sister",
    img: IMG.riri,
    gallery: [{ src: IMG.human, label: "RiRi / In the Manager's Arms" }],
    look: "A plush, dark brown cat with amber eyes and a permanent expression of mild, dignified judgment. (The original RiRi, a short-haired black cat, has left the building. This is her replacement.)",
    summary:
      "Utterly calm, collected, and unbothered by the Hollywood drama. RiRi watches Sam zip past with the serenity of someone who has seen every season of this show already.",
    traits: [
      "Master of the slow blink, the show's best punchline",
      "Can't be rushed, bribed, or impressed",
      "Secretly the only one who knows where every one of Sam's hiding spots is",
      "The Human's favorite to hold, and she tolerates it with royal patience",
    ],
    comedic:
      "RiRi is the straight woman. The louder things get, the stiller she sits. Her reaction shots end the scenes.",
    heart:
      "RiRi quietly steadies the house. When Sam overreaches, one look from her sister is enough.",
    catchphrase: "(Slow blink.)",
  },
  {
    id: "jack",
    name: "Jack",
    alias: "The Laid-Back Brother",
    role: "The Zen Sunbather",
    img: IMG.jack,
    gallery: [],
    look: "A gorgeous gold-coated tabby with green eyes, usually found flat out in the best sunbeam on the terrace.",
    summary:
      "Completely chilled out. Jack soaks up the Malibu sun and watches the household commotion with Zen-like detachment. He's the calmest surfer who never touches the water.",
    traits: [
      "Moves exactly as far as the sunbeam does",
      "Unfazed by explosions, parties, film crews, or Pomeranians",
      "One of Samantha's 'men', and she's fiercely protective of him",
      "His rare moments of effort are treated like major plot events",
    ],
    comedic:
      "Jack's stillness is the running gag. The camera cuts back to him mid-chaos, and he's shifted one inch, maybe.",
    heart:
      "Jack is the proof that the estate is home. Wherever he's lying is the calmest place in Malibu.",
    catchphrase: "(Rolls over.)",
  },
  {
    id: "human",
    name: "The Human",
    alias: "The Manager / Assistant",
    role: "Long-Suffering Resident",
    img: IMG.human,
    gallery: [],
    look: "Thirties, easy smile, gray tee, a ring on his finger and a cat (RiRi) permanently in his arms.",
    summary:
      "The long-suffering resident who thinks he owns the estate. He has no idea he's just staff, managing Samantha's elite lifestyle, taking her calls, running her schedule, and fixing her messes.",
    traits: [
      "Firmly believes 'This is MY house', the show's recurring delusion",
      "Handles logistics, damage control, and apology gift baskets",
      "Is the reason Samantha's 'men' are plural, and adores her despite himself",
      "His plans never survive past the cold open",
    ],
    comedic:
      "He keeps announcing a plan and Samantha keeps rewriting it. His talking-head confessionals give the audience someone to relate to.",
    heart:
      "He's devoted to the cats, and slowly learns that being Sam's person beats being the owner.",
    catchphrase: "Okay. Okay. This is fine. This is my house.",
  },
  {
    id: "neighbors",
    name: "The Neighbors & Visitors",
    alias: "The Recurring Guests",
    role: "Guests, Rivals & Collateral",
    img: IMG.pr,
    gallery: [],
    look: "A rotating parade of coastal characters who walk up the long drive and never leave the same way they came in.",
    summary:
      "Beachgoers, delivery drivers subjected to welcome-committee kisses, and local celebrity pets trying (and failing) to out-diva Samantha.",
    traits: [
      "Marco, the delivery driver: his routes run long because the Welcome Committee won't let him leave without clearance",
      "Duchess Von Pawffe: the influencer Pomeranian next door, with 2M followers and zero chance",
      "Beachgoers: gawk up the cliff at 'that house with the cat on the balcony'",
      "Delphine, the magazine photographer: came for the architecture, stayed for the star",
    ],
    comedic:
      "Guests are the pressure valve. Every visitor raises the stakes, and every one of them eventually gets kissed.",
    heart:
      "Outsiders show how magnetic Sam is. Everyone who arrives a skeptic leaves a fan.",
    catchphrase: "\"Is… is the cat running this?\"",
  },
];

export const BEATS = [
  { id: "beat-1", n: 1, act: "Cold Open", title: "The Drone Shot",
    text: "A cinematic drone sweeps over the Pacific and climbs the Malibu hills to a sun-drenched modern estate. The Human's voiceover explains, proudly, that this is his house. The drone slows at the terrace railing and a sleek black cat stares straight into the lens. She swats it. Static. SMASH CUT TO: TITLE CARD — THEN CAME SAM." },
  { id: "beat-2", n: 2, act: "Cold Open", title: "Morning Patrol",
    text: "Samantha begins her rounds at full speed: kitchen, stairs, pool deck, closet. Jack is flat in a sunbeam. RiRi sits on the ottoman and slow-blinks as Sam zips past for the fourth time. The Human, holding coffee, is nearly taken out at the ankles." },
  { id: "beat-3", n: 3, act: "Act One", title: "The Big Announcement",
    text: "The Human reveals his dream: Malibu Living magazine is sending a photographer to shoot the estate for its cover feature, 'The Hilltop House.' He thinks the story is about architecture. In her command chair, Samantha's ears rotate. It's a photoshoot, which means it's a premiere." },
  { id: "beat-4", n: 4, act: "Act One", title: "The Call Sheet",
    text: "The Human sets up a staged, spotless house with a strict schedule: no cats in frame. He tapes a call sheet to the fridge. By the next shot the call sheet is gone, and Sam has a very suspicious crumple under her paw. In a talking head he insists: 'I am the name on the mailbox.'" },
  { id: "beat-5", n: 5, act: "Act One", title: "Wardrobe",
    text: "Sam gets ready. She finds the gold chain, rejects two throw pillows as 'off-brand', and relocates her command chair to the exact spot where the natural light is best. Jack is given a better sunbeam as a gift. He doesn't notice." },
  { id: "beat-6", n: 6, act: "Act One", title: "The Welcome Committee",
    text: "The doorbell rings. It's Marco with the photographer's gear, then Delphine the photographer, then a stylist. Each one gets stopped at the threshold for a mandatory door-security kiss. Nobody gets in without clearance. Marco is now 40 minutes behind on his route and strangely happy about it." },
  { id: "beat-7", n: 7, act: "Act One Break", title: "Sam Has Left the Building",
    text: "The Human does a final sweep before the first shot: no cats in frame. Jack is outside and RiRi is on the ottoman. Samantha is nowhere. Every door is closed and every window is locked. She's gone. HARD OUT." },
  { id: "beat-8", n: 8, act: "Act Two", title: "The Search",
    text: "The Human, Delphine, the stylist and a returning Marco search the estate. They check the oven, the wine fridge, the chandelier, and the rolled-up designer rug. RiRi watches each wrong guess with increasing pity. Jack rolls over." },
  { id: "beat-9", n: 9, act: "Act Two", title: "Every Frame",
    text: "Delphine reviews her test shots and freezes. A pair of gold eyes is in the corner of every photo: inside the fruit bowl, behind the art, and reflected in the infinity pool. Sam hasn't been hiding from the shoot. She's been in all of it." },
  { id: "beat-10", n: 10, act: "Midpoint", title: "Enter Duchess",
    text: "The influencer next door arrives uninvited with Duchess Von Pawffe, a Pomeranian in a tiara, who is 'perfect for the cover.' Two divas, one cover. Sam reappears in the command chair with the lights behind her, and a turf war begins." },
  { id: "beat-11", n: 11, act: "Act Two", title: "The Takeover",
    text: "The chaos escalates quickly. Sam trips the smart-home system and the blinds go up and down on beat. The sprinklers soak Duchess's ring light. The stylist's lint roller vanishes and turns up in the pool. Delphine can't stop shooting, and none of the shots show the house." },
  { id: "beat-12", n: 12, act: "Act Two Break", title: "All Is Lost",
    text: "The editor calls because the deadline is in an hour. The living room is a disaster, Duchess is sulking, and the Human's cover is ruined. He sinks to the floor of the walk-in closet and admits in a talking head that maybe it isn't his house after all." },
  { id: "beat-13", n: 13, act: "Act Three", title: "The Soft Spot",
    text: "Silence, and then a small black head appears from the shoe rack. Sam climbs into the Human's lap. Door-security kiss. Then another. RiRi settles against him and Jack wanders in (a major event). For one beat the whole family is together. Delphine, standing in the doorway, gets the shot." },
  { id: "beat-14", n: 14, act: "Act Three", title: "The Cover",
    text: "Days later, a copy of Malibu Living lands on the doormat. The cover is Samantha framed in golden light on the terrace. The headline reads: 'THE STAR OF THE HILLTOP.' Inside, the Human's photo credit reads: 'Estate Manager.' Duchess's owner cancels her subscription." },
  { id: "beat-15", n: 15, act: "Tag", title: "Then Came Sam",
    text: "The Human hangs the framed cover and turns around, and Sam is gone again. RiRi slow-blinks toward the magazine rack, where Sam is curled inside it. Jack moves one inch. Sam looks straight into the camera. CUT TO BLACK." },
];

export const EPISODES = [
  { n: "101", title: "Then Came Sam", crisis: "A magazine photoshoot of 'his' house becomes Samantha's cover debut.", level: 1 },
  { n: "102", title: "Clearance Required", crisis: "A new delivery app sends 30 drivers in one afternoon. The Welcome Committee processes every one of them.", level: 2 },
  { n: "103", title: "The Chair", crisis: "The Human buys an ergonomic office chair. Sam treats it as a hostile takeover of the throne.", level: 3 },
  { n: "104", title: "Smart House, Smarter Cat", crisis: "An AI security system is installed. Sam finds 14 blind spots and starts using the system's cameras to spy on the Human.", level: 4 },
  { n: "105", title: "Duchess Moves In", crisis: "Duchess Von Pawffe stays at the estate for a week while her owner's house is fumigated.", level: 5 },
  { n: "106", title: "Red Carpet on the PCH", crisis: "The Human hosts a dinner party for his boss. Sam hosts it instead, with a seating chart and a velvet rope.", level: 6 },
  { n: "107", title: "Road Trip to the Vet", crisis: "A two-mile drive down the Pacific Coast Highway becomes a paparazzi chase, a beach rescue and a drone standoff.", level: 7 },
  { n: "108", title: "The Houseguest", crisis: "The Human's new girlfriend moves in, bringing her golden retriever. Sam has to decide whether she's a rival or staff.", level: 8 },
  { n: "109", title: "Open House", crisis: "A realtor says the estate is going to be sold. The deed is found, and it's held in a trust for the benefit of 'Samantha.'", level: 9 },
  { n: "110", title: "Lights, Camera, Sam", crisis: "A Hollywood studio rents the estate for a feature film. By the last day of the shoot, Sam has been cast.", level: 10 },
];

export const MOTIFS = [
  { id: "kisses", title: "The Welcome Committee", tag: "Door Security Kisses",
    text: "Nobody crosses the threshold without a kiss. It starts with one delivery driver and escalates to lines down the drive, a fire marshal, a studio executive and a SWAT negotiator.",
    ladder: ["1 driver", "30 drivers", "Fire marshal", "A studio head", "Live on the news"] },
  { id: "hiding", title: "Impossible Hiding Spots", tag: "Where Is Sam?",
    text: "Every episode tops the last one. She's been found in the rug, the chandelier, the magazine rack, the smart fridge's ice maker, the rental Bentley's glovebox and, eventually, the film set's green screen.",
    ladder: ["The rug", "The chandelier", "Inside the AI camera", "The Bentley", "In the movie"] },
  { id: "chair", title: "The Command Chair", tag: "Holding Court",
    text: "When Sam sits in her custom chair, the episode shifts into a summit scene. Whoever takes the chair (a houseguest, a Pomeranian, or the Human) sets off the week's crisis.",
    ladder: ["Chair moved", "Chair replaced", "Chair stolen", "Chair on a float", "Chair in the Academy"] },
  { id: "siblings", title: "Sibling Reaction Shots", tag: "Calm, Cool, Collected",
    text: "Each act ends with a hard cut to RiRi's slow blink or Jack's one-inch roll. The bigger the disaster, the smaller their reaction, and the audience learns to wait for it.",
    ladder: ["Slow blink", "Double blink", "Jack sits up", "RiRi leaves the room", "Jack stands (season finale)"] },
  { id: "delusion", title: "\"This Is My House\"", tag: "The Human's Delusion",
    text: "Each episode the Human says it with more confidence, just as more evidence shows otherwise. That runs from the name on the mailbox to the Wi-Fi password and finally to the deed.",
    ladder: ["Mailbox", "Wi-Fi name", "Seating chart", "Security logs", "The deed"] },
];

export const ARC = [
  { season: "Season One", title: "The Estate", tag: "Who Really Runs This House?",
    text: "The Human believes he's the owner. Across ten episodes, each wilder than the last, Samantha proves otherwise, and in Episode 109 the deed confirms it. By the finale he accepts his real title: Estate Manager. Sam gets her first screen credit." },
  { season: "Season Two", title: "The Brand", tag: "Malibu Goes Viral",
    text: "After the movie, Sam is famous, with fans at the gate, sponsors at the door and Duchess plotting a comeback. The Welcome Committee becomes a full security operation. RiRi quietly becomes Sam's manager, and Jack becomes a meme without moving." },
  { season: "Season Three", title: "The Empire", tag: "Queen of the Coast",
    text: "Sam expands her estate to the whole hilltop. That includes rival estates, a neighborhood council and a beachfront awards show. The series ends where it began, with a drone over Malibu. This time it's Sam's drone." },
];

export const PREVIEW_BEATS = ["beat-1", "beat-6", "beat-9"];
export const PREVIEW_EPISODES = ["102", "104", "109"];
